import Grid from '@zenbusiness/zui/Grid';
import PageContainer from '@zenbusiness/zui/PageContainer';
import Skeleton from '@zenbusiness/zui/Skeleton';
import Stack from '@zenbusiness/zui/Stack';

import * as Styled from './BusinessProfileSkeleton.style';

const INFO_LENGTH = 6;
const ITEM_LENGTH = 2;

function BusinessProfileSkeleton() {
  return (
    <PageContainer display="flex" flexDirection="column" gap={3}>
      <Skeleton width="30%" height="3rem" />
      <Styled.Header title={<Skeleton width="50%" height="5rem" />} />
      <Styled.Content size="lg">
        <Skeleton width="30%" height="3rem" />
        <Grid container spacing={3}>
          {Array.from({ length: INFO_LENGTH }, () => null).map((_, i) => (
            <Grid item xs={12} md={6} key={`info-${i.toString()}`}>
              <Stack spacing={0.5}>
                <Skeleton width="40%" height="2rem" />
                {Array.from({ length: ITEM_LENGTH }, () => null).map((__, j) => (
                  <Skeleton width="80%" height="1rem" key={`item-${j.toString()}`} />
                ))}
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Styled.Content>
    </PageContainer>
  );
}

export default BusinessProfileSkeleton;
